import CustomDeleteDialog from 'core/components/CustomDeleteDialog'
import { getCurrentUser } from 'openstack/helpers'
import { useCallback, useMemo } from 'react'
import { deleteVirtualMachine } from './actions'
import { hasOtherUserVm } from './helpers'
import { LAYER_2_PORT_METADATA_KEY } from './utils/vmBodyBuilder'

const DeleteVirtualMachineDialog = (props) => {
  const { role: userRole, userId } = getCurrentUser()
  const { rows, onDeleteSuccess } = props
  const { clusterName, nodePoolName } = rows[0]?.metadata || {}

  const infoMessage = useMemo(() => {
    if (clusterName && nodePoolName) {
      return {
        showInfo: true,
        message: `NOTE: Deleting this VM will also impact the cluster - ${clusterName}`,
      }
    }
    if (userRole === 'member' && hasOtherUserVm({ vms: rows, userId }))
      return {
        showInfo: true,
        message: "NOTE: You are performing an operation on another user's VM.",
      }

    return {
      showInfo: false,
      message: '',
    }
  }, [clusterName, nodePoolName, rows, userId, userRole])

  const buildBodyFn = useCallback(
    (row) => ({
      id: row?.id,
      simpleNetworkPorts: row?.metadata?.[LAYER_2_PORT_METADATA_KEY]?.split(',') ?? [],
    }),
    [],
  )

  return (
    <CustomDeleteDialog
      {...props}
      deleteAction={deleteVirtualMachine}
      title="Delete Virtual Machine(s)"
      resourceLabel="VM instance(s)"
      showInfo={infoMessage.showInfo}
      infoMessage={infoMessage.message}
      onDeleteSuccess={onDeleteSuccess}
      buildBodyFn={buildBodyFn}
    />
  )
}

export default DeleteVirtualMachineDialog
